import classNames from 'classnames';
import * as React from 'react';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './PlayButton.module.css';

interface PlayButtonProps {
    onClick: () => void;
    label: string;
    buttonRef?: React.RefObject<HTMLButtonElement>;
    className?: string;
}

export const PlayButton: React.FC<PlayButtonProps> = props => {
    const { onClick, buttonRef, label, className } = props;

    return (
        <Button
            className={classNames(styles.PlayButton, className)}
            ref={buttonRef}
            type={ButtonType.Clear}
            size={ButtonSize.Medium}
            onClick={onClick}
            title={label}
        >
            <span className="visuallyHidden">{label}</span>
            <SvgIcon iconName="play" />
        </Button>
    );
};
